import {
	Box,
	Grid,
	FormControl,
	InputLabel,
	Select,
	MenuItem,
	TextField,
	InputAdornment,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EditIcon from "@mui/icons-material/Edit";
import dayjs from "dayjs";
import React from "react";
import { sizes } from "../../setupUtils";
import { useDispatch, useSelector } from "react-redux";
import { resetAllStates, setPGState } from "../productGroupSetupSlice";

export default function CreatePG() {
	const pgState = useSelector((store) => store.productGroupSetup);
	const { countries, country, createPGName, createFromDate, createToDate, selectedSKUs } =
		pgState;
	const dispatch = useDispatch();

   const minDate = dayjs().add(1, 'day');

	function showMessage(message, severity) {
		dispatch(setPGState("createMessageOpen", true));
		dispatch(setPGState("createMessage", message));
		dispatch(setPGState("createMessageSeverity", severity));
	}

	function updateCountry(event) {
      dispatch(resetAllStates({ edit: false }));
		const name = event.target.value;
		const id = countries.find(
			(country) => country.countryName === name
		).countryID;
		dispatch(setPGState("country", name));
		dispatch(setPGState("countryID", id));
	}

	function updatePGName(event) {
		const pattern = /^[a-zA-Z0-9 ]*$/;
		if (event.target.value == " ") {
		  event.target.value = event.target.value.replace(" ", "");
		}
		else if (event.target.value.startsWith(" ")) {
		  event.target.value = event.target.value.trimStart();
		}
		if (!pattern.test(event.target.value)) {
		  event.target.value = event.target.value.replace(/[^a-zA-Z0-9 ]/g, "");	
		}
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
			return;
		}
		const name = event.target.value;
		dispatch(setPGState("createPGName", name));
	}

	function updateFromDate(newDate) {
		if (country.length <= 0) {
			showMessage("Please select a country", "info");
         dispatch(setPGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
		if (newDate >= createToDate) {
			showMessage("From Date cannot be greater than To Date", "info");
         dispatch(setPGState("createFromDate", dayjs().add(1, "day")));
			return;
		}
      console.log("CreatePG_UpdateFromDate", newDate)
		dispatch(setPGState("createFromDate", newDate));
      if(selectedSKUs.length > 0) {
         setSelectedSKUFromDates(newDate);
      }
	}

	function updateToDate(newDate) {
      if (country.length <= 0) {
			showMessage("Please select a country", "info");
         dispatch(setPGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		if (newDate <= createFromDate) {
			showMessage("To Date cannot be less than From Date", "info");
         dispatch(setPGState("createToDate", dayjs("2099-12-31T00:00:00.000Z")));
			return;
		}
		dispatch(setPGState("createToDate", newDate));
      if(selectedSKUs.length > 0) {
         setSelectedSKUTODates(newDate);
      }
	}

   function setSelectedSKUFromDates(date) {
      const selSKUs = selectedSKUs.map((item) => {
         return {
            ...item,
            effectiveStartDate: date, 
         };
      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

   function setSelectedSKUTODates(date) {
      const selSKUs = selectedSKUs.map((item) => {
         return {
            ...item,
            effectiveEndDate: date, 
         };
      });
      dispatch(setPGState("selectedSKUs", selSKUs));
   }

	return (
		<Box>
			<Box
				sx={{
					mt: 3,
				}}
			>
				<Grid container columns={8} spacing={3} rowGap={2}>
					<Grid item sm={2}>
						<FormControl sx={{widows:"100%"}}>
							<InputLabel>Country</InputLabel>
							<Select
								value={country}
								label="Country"
								onChange={updateCountry}
							>
								{countries.map((country, index) => {
									return (
										<MenuItem key={index} value={country.countryName}>
											{country.countryName}
										</MenuItem>
									);
								})}
							</Select>
						</FormControl>
					</Grid>

					<Grid item sm={2}>
						<TextField
							label="Product Group Name"
							InputProps={{
								startAdornment: (
									<InputAdornment position="end">
										<EditIcon />
									</InputAdornment>
								),
							}}
							variant="standard"
							value={createPGName}
							onChange={updatePGName}
						/>
					</Grid>

					<Grid item sm={2}>
						<Box sx={{ mt: 1 }}>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									minDate={minDate}
									label="From"
									value={createFromDate}
									onChange={(newValue) => updateFromDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>

					<Grid item sm={2}>
						<Box sx={{ mt: 1 }}>
							<LocalizationProvider dateAdapter={AdapterDayjs}>
								<DatePicker
									minDate={minDate}
									label="To"
									value={createToDate}
									onChange={(newValue) => updateToDate(newValue)}
									renderInput={(params) => (
										<TextField
											{...params}
											size="small"
											sx={{ width: sizes.w200 }}
										/>
									)}
									format="DD/MM/YYYY"
								/>
							</LocalizationProvider>
						</Box>
					</Grid>
				</Grid>
			</Box>
		</Box>
	);
}
